const WORK_DIALOG_SIZES = Object.freeze({
  EXTRA_SMALL: 'xs',
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  EXTRA_LARGE: 'xl',
  FULL_SIZE: 'fs'
});

export default WORK_DIALOG_SIZES;
